import React from "react";
import { useOutletContext } from "react-router-dom";
import { useSettings } from "@/contexts/SettingsContext";
import { Phone, Mail, MapPin, Clock, MessageCircle } from "lucide-react";

export default function ContactPage() {
  const { openForm } = useOutletContext();
  const { settings } = useSettings();
  const wa = (settings?.whatsapp || "").replace(/[^0-9]/g, "");
  const waLink = wa ? `https://wa.me/${wa}` : "#";

  const items = [
    { icon: Phone, label: "Telefon", value: settings.phone, href: `tel:${settings.phone}` },
    { icon: Mail, label: "E-posta", value: settings.email, href: `mailto:${settings.email}` },
    { icon: MapPin, label: "Adres", value: settings.address },
    { icon: Clock, label: "Çalışma Saatleri", value: settings.working_hours },
  ];

  return (
    <div className="max-w-7xl mx-auto px-6 lg:px-8 py-20">
      <div className="max-w-3xl">
        <span className="text-xs uppercase tracking-[0.25em] asg-primary font-semibold">İletişim</span>
        <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-semibold mt-3 tracking-tight" data-testid="contact-title">
          Bize <span className="asg-primary">ulaşın</span>
        </h1>
        <p className="mt-6 text-lg text-zinc-300 leading-relaxed">
          Sorularınız için WhatsApp üzerinden anında yazabilir veya talep formunu doldurabilirsiniz.
        </p>
      </div>

      <div className="grid lg:grid-cols-3 gap-6 mt-14">
        {items.map((i) => (
          <div key={i.label} className="asg-card rounded-2xl p-8" data-testid={`contact-${i.label}`}>
            <div className="h-11 w-11 rounded-xl flex items-center justify-center mb-4" style={{ background: "rgba(230,32,32,0.12)" }}>
              <i.icon className="w-5 h-5 asg-primary" />
            </div>
            <div className="text-xs uppercase tracking-widest text-zinc-500">{i.label}</div>
            {i.href ? (
              <a href={i.href} className="mt-1.5 block font-heading text-lg text-white hover:asg-primary transition-colors">{i.value}</a>
            ) : (
              <div className="mt-1.5 font-heading text-lg text-white">{i.value}</div>
            )}
          </div>
        ))}
      </div>

      <div className="mt-10 flex flex-wrap gap-4">
        <button
          onClick={() => openForm(null)}
          className="asg-btn-primary rounded-full h-12 px-7 font-semibold"
          data-testid="contact-request-btn"
        >
          Talep Formu Doldur
        </button>
        <a
          href={waLink}
          target="_blank"
          rel="noreferrer"
          className="inline-flex items-center gap-2 h-12 px-7 rounded-full border border-white/15 text-white hover:border-white/30 transition-colors"
          data-testid="contact-whatsapp-btn"
        >
          <MessageCircle className="w-5 h-5 text-emerald-400" /> WhatsApp
        </a>
      </div>
    </div>
  );
}
